import { render } from "./ShowLoading.vue?vue&type=template&id=3f3adbd4&lang=pug"
import script from "./ShowLoading.vue?vue&type=script&lang=js"
export * from "./ShowLoading.vue?vue&type=script&lang=js"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__